<template>
  <div class="">
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6 detail-r">
      <b-row>
        <b-col>
          <div class="card-wrapper detail-content">
            <template>
              <card style="width:100%">
                <!-- Card header -->
                <div slot="" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">SwiftStorm 是基于Transformer AI大模型训练的中短线趋势策略</h3>
                            <p style="margin-top:5px">
                                投喂过去20年的期货、股市、汇率、新闻等数据，以及交易大师们的经典交易手法，进行模型训练和深度学习生成的交易策略；
                                <br/>以下数据为AI结合实盘，实时计算的结果，仅作技术研究和分享，不构成任何投资建议。
                            </p>

                            <p style="margin-top:0px;color:red" v-if="!isVIP">
                               <a style="margin-top:0px;color:red" href="/#/home/pricing">数据仅对会员开放，您需购买算力服务后即可正常显示策略信息，欢迎咨询购买。</a>
                            </p>

                        </div>
                        <div style="margin-right: 10px" lg="6" cols="5" class="text-right">
                            <el-select
                            class="select-primary pagination-select"
                            v-model="category"
                            placeholder="分类筛选"
                            style="margin-left: 10px; width: 150px"
                            >
                             <el-option
                              class="select-primary"
                              key=""
                              label="分类筛选"
                              value=""
                            ></el-option>
                            <el-option
                              class="select-primary"
                              v-for="(item, index) in categoies"
                              :key="index"
                              :label="item"
                              :value="index"
                            >
                            </el-option>

<!--                             
                          
                            <el-option
                                class="select-primary"
                                key="category_1"
                                label="贵金属"
                                value="1"
                            >
                            </el-option> -->

                            
                            </el-select>
                            <base-button
                            style="margin-left: 30px"
                            type="success"
                            @click.native="handleChat()"
                            >向AI提出意见建议</base-button
                            >
                        </div>
                    </b-col>
                </div>
                 <!-- End Card header -->
               
                <!-- Card body -->
              </card>

               <card style="width:100%;margin-top:-10px">
                <!-- Card header -->
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">持仓订单</h3>
                            <p style="margin-top:5px">
                                <!-- 多头持仓：<font color="red">{{l_current_volume}}</font>&nbsp;
                                空头持仓：<font color="green">{{s_current_volume}}</font>&nbsp; -->
                                 <span v-if="l_current_volume_count > 0">多头持仓：<font color="red">{{l_current_volume_count}}个 ({{l_current_volume}}手)</font>&nbsp;</span>
                 
                                <span v-if="s_current_volume_count > 0">空头持仓：<font color="green">{{s_current_volume_count}}个 ({{s_current_volume}}手)</font>&nbsp;</span>
                 
                                逐笔盈亏：
                                <font v-if="float_porfit_o>=0" color="red">¥{{float_porfit_o_str}}</font>
                                <font v-if="float_porfit_o<0" color="green">¥{{float_porfit_o_str}}</font>
                                &nbsp;
                                逐笔平仓盈亏：
                                <font v-if="exit_float_porfit_o>=0" color="red">¥{{exit_float_porfit_o_str}}</font>
                                <font v-if="exit_float_porfit_o<0" color="green">¥{{exit_float_porfit_o_str}}</font>
                            </p>
                        </div>
                       <div style="margin-right: 10px" lg="6" cols="5" class="text-right">
                           
                            <base-button
                            style="margin-left: 30px"
                            type="primary"
                            @click.native="locationToPrice()"
                            >购买算力</base-button
                            >
                        </div>
                       
                    </b-col>
                </div>
<!-- @sort-change="sortChange"
              @selection-change="selectionChange" -->
                 <el-table
              :data="tableData"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="id"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              <!-- <el-table-column min-width="180px" align="right" label="Actions">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    type="success"
                    >编辑</base-button
                  >

                  <base-button
                    v-if="row.is_fav == 0"
                    @click.native="handleLike($index, row, 1)"
                    type="success"
                    >加入自选</base-button
                  >
                  <base-button
                    v-if="row.is_fav == 1"
                    @click.native="handleLike($index, row, 0)"
                    type="warning"
                    >取消自选</base-button
                  >
                </div>
              </el-table-column> -->
            </el-table>
                 <!-- End Card header -->
               
                <!-- Card body -->
              </card>

              <card style="width:100%;margin-top:-10px">
                <!-- Card header -->
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">今日委托成交、今已平</h3>
                        </div>
                    </b-col>
                </div>

              <el-table
              :data="tableData1"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="contract"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns1"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              
            </el-table>
              </card>

              <card style="width:100%;margin-top:-10px">
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">资金曲线</h3>
                        </div>
                    </b-col>
                </div>

             <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>
              </card>

            </template>

          </div>
        </b-col>
      </b-row>
   
      <!-- End charts-->
    </b-container>

  </div>
</template>


<script>
import * as chartConfigs from "@/components/Charts/config";
import futureApi from "../../api/future";
import accountApi from "../../api/account";
import configs from "../../config/index";
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
// import { BasePagination } from "@/components";
import clientPaginationMixin from "../LinearSwap/PaginatedTables/clientPaginationMixin";
import PriceLabel from "../LinearSwap/priceLabel";
import LineChart from "@/components/Charts/LineChart";
var moment = require("moment");
const numeral = require('numeral');

export default {
  mixins: [clientPaginationMixin],
  name: "form-components",
  components: {
    PriceLabel,
    LineChart,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      isVIP:true,
      checkAndPlayerSoundId:0,
      category:"",
      categoies:{},
      l_current_volume:0,
      s_current_volume:0,
      l_current_volume_count:0,
      s_current_volume_count:0,
      float_porfit_o:0,
      float_porfit_o_str:"0",

      exit_float_porfit_o:0,
      exit_float_porfit_o_str:"0",

      propsToSearch: ["code"],
      tableColumns1:[
        {
          prop: "category_name",
          label: "分类",
          minWidth: 120,
          sortable: false,
        },
        {
          prop: "name",
          label: "名称",
          minWidth: 140,
          sortable: false,
        },
        {
          prop: "code",
          label: "合约",
          minWidth: 120,
          sortable: false,
          formatter: this.formatterContract,
        },
        {
          prop: "buy_sell",
          label: "买卖",
          minWidth: 100,
          sortable: false,
          formatter: this.formatterSignalBuySell,
        },
        {
          prop: "deal_type",
          label: "开平",
          minWidth: 100,
          sortable: false,
          formatter: this.formatterSignalDealType,
        },
        {
          prop: "lots",
          label: "成交数量",
          minWidth: 100,
          sortable: false,
          // formatter: this.formatterPriceWinLose,
        },
        {
          prop: "signal_porfit",
          label: "盈亏",
          minWidth: 120,
          sortable: false,
          formatter: this.formatterSignalWinLose,
        },
        {
          prop: "exchange_name",
          label: "交易所",
          minWidth: 250,
          sortable: false,
        },
        {
          prop: "created_at",
          label: "时间",
          minWidth: 250,
          sortable: false,
          formatter: this.formatterDateTime,
          
        },

      ],
      tableColumns: [
        {
          prop: "category_name",
          label: "分类",
          minWidth: 120,
          sortable: true,
        },
        {
          prop: "name",
          label: "名称",
          minWidth: 120,
          sortable: true,
        },
        {
          prop: "contract",
          label: "合约",
          minWidth: 120,
          sortable: true,
          formatter: this.formatterContract,
        },
        {
          prop: "l_current_volume",
          label: "净持仓",
          minWidth: 120,
          sortable: true,
          formatter: this.formatterCurrentVolume,
        },
        // {
        //   prop: "s_current_volume",
        //   label: "空持仓",
        //   minWidth: 120,
        //   sortable: true,
        //   // formatter: this.formatterPrice,
        // },
        {
          prop: "l_avg_price_o",
          label: "逐笔均价",
          minWidth: 150,
          sortable: false,
          formatter: this.formatterAvgPrice,
        },
        {
          prop: "float_profit_o",
          label: "逐笔盈亏",
          minWidth: 150,
          sortable: true,
          formatter: this.formatterPriceWinLose,
        },

        {
          prop: "l_use_margin_amount",
          label: "保证金",
          minWidth: 150,
          sortable: false,
          formatter: this.formatterUseMarginAmount,
        },
        {
          prop: "l_market_value",
          label: "净市值",
          minWidth: 160,
          sortable: false,
          formatter: this.formatterMarketValue,
        },
        {
          prop: "exchange_name",
          label: "交易所",
          minWidth: 200,
          sortable: true,
        },
      ],

      tableData: [],
      tableData1: [],

      selectedRows: [],

      bigLineChart: {
        allData: [[0, 0, 0, 0, 0, 0, 0]],
        activeIndex: 0,
        extraOptions: chartConfigs.blueChartOptions,
        chartData: {
          datasets: [
            {
              label: "Performance",
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
            },
          ],
          labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        },
      },
    };
  },
   watch: {
    category: function (val) {
      // this.reloadData();
      // console.log("-----------category==",val);
      this.getLists(val)
    },
  },
  methods: {
    locationToPrice()
    {
      window.location.href = "/#/home/pricing";
    },
    async handleChat()
    {
      const content = "#AI策略-SwithStrom思路和建议 "
      localStorage.setItem('chatContent', content);
      window.location.href = "/#/AI";
    },

    formatterContract(value, cloumn) {
      const str = value[cloumn.property];
      if(!str || str == "" || str == undefined)
      {
        return "";
      }
      // console.log("=======str:", str);
      const val = str.split(".");
      // console.log("=======val:", val[0]);
      return val[0];
    },
    formatterPriceWinLose(value, cloumn) {
      const l_current_volume = value["l_current_volume"];
      const s_current_volume = value["s_current_volume"];

      let float_profit_o = 0;
      if(l_current_volume > 0)
      {
        float_profit_o = parseFloat(value["l_float_porfit_o"]);
      }
      else if(s_current_volume > 0)
      {
        float_profit_o = parseFloat(value["s_float_porfit_o"]);
      }
  

      let priceClassName;
      if (float_profit_o > 0) {
        priceClassName = "text-danger";
      } else if (float_profit_o < 0) {
        priceClassName = "text-success";
      }

      let formattedNumber = numeral(float_profit_o).format('0,0.00');
      return this.$createElement("price-label", {
        props: { priceClassName, price: "¥" + formattedNumber },
      });

    },

    formatterSignalWinLose(value, cloumn) {

      let deal_type = value["deal_type"];
      if (deal_type == 'enterTrade') {
        return "-";
      }
      let float_profit_o = value["signal_porfit"];
      let priceClassName;
      if (float_profit_o > 0) {
        priceClassName = "text-danger";
      } else if (float_profit_o < 0) {
        priceClassName = "text-success";
      }

      let formattedNumber = numeral(float_profit_o).format('0,0.00');
      return this.$createElement("price-label", {
        props: { priceClassName, price: "¥" + formattedNumber },
      });

    },

    formatterSignalBuySell(value, cloumn) {

      if(!this.isVIP)
      {
        return "***"
      }

      let val = value["buy_sell"];
      let str = "";
      let priceClassName;
      if (val == 'buy') {
        priceClassName = "text-danger";
        str = "买入";
      } else if (val == 'sell') {
        priceClassName = "text-success";
        str = "卖出";
      }

      return this.$createElement("price-label", {
        props: { priceClassName, price: str },
      });

    },

    formatterSignalDealType(value, cloumn) {

      if(!this.isVIP)
      {
        return "***"
      }

      let val = value["deal_type"];
      let str = "";
      let priceClassName;
      if (val == 'enterTrade') {
        priceClassName = "text-danger";
        str = "开仓";
      } else if (val == 'exitTrade') {
        priceClassName = "text-success";
        str = "平仓";
      }

      return this.$createElement("price-label", {
        props: { priceClassName, price: str },
      });

    },

    formatterCurrentVolume(value, cloumn) {
      if(!this.isVIP)
      {
        return "***"
      }
      const l_current_volume = value["l_current_volume"];
      const s_current_volume = value["s_current_volume"];
      // console.log("l_current_volume:", l_current_volume);
      // console.log("s_current_volume:", s_current_volume);
      let currentVolume = 0;
      if(l_current_volume > 0)
      {
        currentVolume = l_current_volume;
      }
      else if(s_current_volume > 0)
      {
        currentVolume = s_current_volume * -1;
      }

      let priceClassName;
      if (currentVolume > 0) {
        priceClassName = "text-danger";
      } else {
        priceClassName = "text-success";
      }

      return this.$createElement("price-label", {
        props: { priceClassName, price: currentVolume.toFixed(0) },
      });

    },
    formatterMarketValue(value, cloumn) {
      const l_current_volume = value["l_current_volume"];
      const s_current_volume = value["s_current_volume"];
      // const str = value[cloumn.property];
      // console.log("l_current_volume:", l_current_volume);
      // console.log("s_current_volume:", s_current_volume);
      let val = 0;
      if(l_current_volume > 0)
      {
        val = parseFloat(value['l_market_value']);
      }
      else if(s_current_volume > 0)
      {
        val = parseFloat(value['s_market_value']);
      }
      // val.toFixed(2).toLocaleString();
      let formattedNumber = numeral(val).format('0,0.00');
      return "¥" + formattedNumber;

    },
    formatterUseMarginAmount(value, cloumn) {
      const l_current_volume = value["l_current_volume"];
      const s_current_volume = value["s_current_volume"];
      // const str = value[cloumn.property];
      // console.log("l_current_volume:", l_current_volume);
      // console.log("s_current_volume:", s_current_volume);
      let val = 0;
      if(l_current_volume > 0)
      {
        val = parseFloat(value['l_use_margin_amount']);
      }
      else if(s_current_volume > 0)
      {
        val = parseFloat(value['s_use_margin_amount']);
      }
      let formattedNumber = numeral(val).format('0,0.00');
      return "¥" + formattedNumber;
    },
    formatterAvgPrice(value, cloumn) {
      if(!this.isVIP)
      {
        return "***"
      }

      const l_current_volume = value["l_current_volume"];
      const s_current_volume = value["s_current_volume"];
      // const str = value[cloumn.property];
      // console.log("l_current_volume:", l_current_volume);
      // console.log("s_current_volume:", s_current_volume);
      let price = 0;
      if(l_current_volume > 0)
      {
        price = parseFloat(value['l_avg_price_o']);
      }
      else if(s_current_volume > 0)
      {
        price = parseFloat(value['s_avg_price_o']);
      }

      let formattedNumber = numeral(price).format('0,0.00');
      return "¥" + formattedNumber;
     
    },
    formatterDateTime(value, cloumn) {
      let date = value[cloumn.property];
      // console.log("---date:",date);
      var m = moment(date);
      return m.format("YYYY-MM-DD HH:mm");
    },

    //  formatterShock(value, cloumn) {
    //   // console.log("value:", value);
    //   const shockValue = value[cloumn.property];
    //   if (shockValue) {
    //     return this.$createElement("shock-label", {
    //       props: { shockValue: shockValue },
    //     });
    //   } else {
    //     return "-";
    //   }
    // },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    async getLists()
    {
      const category = this.category;
      let fromData = {
        strategy_type:"SwiftStorm",
      }
      if(category && category != undefined && category != "")
      {
        fromData.category = category;
      }
      const res = await futureApi.getStrategy(fromData);
      if (res && res.code == 200) {
        
        const { data } = res;
        this.tableData = data.list;
        this.categoies = data.categoies;
        this.isVIP = data.isVIP;

        this.l_current_volume = data.l_current_volume;
        this.s_current_volume = data.s_current_volume;
        this.l_current_volume_count = data.l_current_volume_count;
        this.s_current_volume_count = data.s_current_volume_count;
        

        this.float_porfit_o = parseFloat(data.float_porfit_o);
        this.float_porfit_o_str = numeral(data.float_porfit_o).format('0,0.00');
        
        // console.log("---futuresLongShort:",this.futuresLongShort)
      }


      let fromData1 = {
        signal_type:"SwiftStorm",
      }
      if(category && category != undefined && category != "")
      {
        fromData1.category = category;
      }
      const res1 = await futureApi.getSignal(fromData1);
      // console.log("---res1:",res1)
      if (res1 && res1.code == 200) {
        
        const { data } = res1;
        const new_list = data.list;

        if(!new_list || new_list.length <= 0)
        {
          return;
        }

        this.exit_float_porfit_o = parseFloat(data.exit_float_porfit_o);
        this.exit_float_porfit_o_str = numeral(data.exit_float_porfit_o).format('0,0.00');
        


        //如果之前没数据，
        if(this.checkAndPlayerSoundId >= 0)
        {
         const checkId = new_list[0].id;
        //  console.log("-----检查是否有新消息",{checkId,checkAndPlayerSoundId:this.checkAndPlayerSoundId},checkId>this.checkAndPlayerSoundId?"---是---":"====否===")
         if(this.checkAndPlayerSoundId > 0 && checkId>this.checkAndPlayerSoundId)
         {
          this.playSignalSound(new_list[0]);
         }
         
        }

        this.tableData1 = new_list;
        if(this.tableData1.length > 0)
        {
          //保存最新一条记录的ID
          if(this.tableData1[0].id > this.checkAndPlayerSoundId)
          {
            this.checkAndPlayerSoundId = this.tableData1[0].id;
          }
        }
      }
     
    },

    async playSignalSound(row)
    {
      if(!this.isVIP)
      {
        return;
      }
      // symbol: "lh.DCE"
      //buy_sell: "buy"
      //deal_type: "enterTrade"

      let buy_sell = row["buy_sell"];
      let deal_type = row["deal_type"];
      let symbol = row["symbol"];
      let name = row["name"];
      let url = configs.CDN_URI + "wav/";
      let str = "";
      if(deal_type == "enterTrade")
      {
        //开仓
        if(buy_sell == "buy")
        {
          //开多
          url += symbol +"-enterlong.wav"
          str = name + "开多";
        }else{
          //开空
          url += symbol +"-entershort.wav"
          str = name + "开空";
        }
      }else if(deal_type == "exitTrade")
      {
        //平仓
        if(buy_sell == "sell")
        {
          //平多
          url += symbol +"-quitlong.wav"
          str = name + "平多";
        }else{
          //平空
          url += symbol +"-quitshort.wav"
          str = name + "平空";
        }
      }

     const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const response = await fetch(url);
      const buffer = await response.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(buffer);
      const source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(audioContext.destination);
      source.start(0);

      this.$notify({
        message: str,
        timeout: 5000,
        icon: "ni ni-bell-55",
        type: "danger"//code == 200 ? "success" : "danger",
      });
    },
    
    async getUserInfo()
    {
      const res = await accountApi.info();
      // console.log("getUserInfo:",res);
      if (res && res.code == 200) {
        const { data } = res;
      }
    },
    async getProfitDaily()
    {
      let fromData = {
        strategy_type:"SwiftStorm",
      }
    
      const res = await futureApi.getProfitDaily(fromData);

      if (res && res.code == 200) {
        const { data } = res;

        let profits = [];
        let labels = [];

        for (let i = 0; i < data.list.length; i++) {
          let item = data.list[i];
          profits.push(item.profit);
          var m = moment(item.date);
          labels.push(m.format("MM-DD"));
        }

        let chartData = {
          datasets: [
            {
              label: "盈亏",
              data: profits,
             
            },
          ],
          labels: labels,
          
        };

        this.bigLineChart.chartData = chartData;

      }
    }


  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
    this.getUserInfo();
    this.getLists();
    this.getProfitDaily();

    this.timer = setInterval(this.getLists, 3000);
  },
};
</script>

<style>

.fee-nav-list {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #bfbfbf;
    padding: 5px 50px 0px;
}
.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item {
    height: 48px;
    box-sizing: content-box;
    padding: 0 25px;
    color: #9d9d9d;
    font-weight: 700;
    font-size: 26px;
    cursor: pointer;
}

.fee-module-body-card {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;

}

.fee-card-pc {
    background-color: #eeeeee;
    box-shadow: 0 23px 27px 0 rgba(215,221,229,.2);
    border-radius: 16px 20px 20px 20px;
    padding-top: 26px;
    width: 205px;
    height: 138px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-left: 14px;

}



.fee-card-pc .fee-card-body-long {
    color: #ff6900;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}

.fee-card-pc .fee-card-body-short {
    color: #41ce09;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}

.fee-card-pc .fee-card-body-none {
    color: #8d8d8d;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}


.fee-card-pc .fee-card-body-title-big {
    font-size: 28px;
}
.fee-card-pc .fee-card-body-title {
    text-align: center;
    font-weight: 500;
    margin-top: 5px;
}

</style>